import Vue from 'vue';
import Vuex from 'vuex';
// import axios from 'axios';
import VuejsDialog from 'vuejs-dialog';
import VuexPersistence from 'vuex-persist';

// import Identities from './modules/Identities/index';
// import Auth from './modules/AuthOld/index';
// import GameServers from './modules/Game-Servers/index';
// import Clients from './modules/Clients/index';
// import JiraUsers from './modules/JiraUsers/index';
// import Worklogs from './modules/Worklogs/index';
// import Projects from './modules/JiraProjects/index';
// import UserRates from './modules/UserRates/index';
// import IncomingPayments from './modules/IncomingPayments/index';
// import WorkloadPlans from './modules/WorkloadPlans/index';
// import AuditLogs from './modules/AuditLogs/index';
// import ProjectFinances from './modules/ProjectFinances/index';
// import ProjectMaterials from './modules/ProjectMaterials/index';
// import Templates from './modules/Templates/index';
// import SpecialBusinessDays from './modules/SpecialBusinessDays/index';
// import Configurations from './modules/Configurations/index';
// import Groups from './modules/Groups/index';
// import PlannedVacations from './modules/PlannedVacations/index';
// import ProjectGraphics from './modules/ProjectGraphics';
// import ProjectOverviews from './modules/ProjectsOverview';
// import RevenuePerMonth from './modules/RevenuePerMonth';
// import Filters from './modules/Filters';
// import UserLogs from './modules/UserLogs';
// import {Jira} from './modules/Jira';

import { VT, VTN } from '@/store/types';
import { modules, defaultState } from './modules';

Vue.use(Vuex);
const persist = new VuexPersistence({
  storage: window.localStorage,
  modules: [
    // 'OfflineModulesHERE',
    'Auth'
  ]
});

Vue.use(VuejsDialog);
Vue.use(Vuex);
export { VT, VTN };
export default new Vuex.Store({
  modules,
  plugins: [persist.plugin],

  mutations: {
    RESET_TO_DEFAULT_STATE: (state, exceptions = []) => {
      let requiredReset = Object.keys(state);
      if (exceptions.length) {
        requiredReset = requiredReset.filter((el) => !exceptions.includes(el));
      }
      requiredReset.forEach((module) => {
        state[module] = defaultState[module]();
      });
    },
  }
  // modules: {
  //     Auth,
  //     Identities,
  //     GameServers,
  //     Clients,
  //     JiraUsers,
  //     Worklogs,
  //     Projects,
  //     Jira,
  //     UserRates,
  //     IncomingPayments,
  //     WorkloadPlans,
  //     AuditLogs,
  //     ProjectFinances,
  //     ProjectMaterials,
  //     Templates,
  //     SpecialBusinessDays,
  //     Configurations,
  //     Groups,
  //     PlannedVacations,
  //     ProjectGraphics,
  //     ProjectOverviews,
  //     RevenuePerMonth,
  //     Filters,
  //     UserLogs
  // }
});
